import Vue from 'vue'
import Vuex from 'vuex'
import Users from './modules/user/users'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: '**-botoffice-data-00-**',
  storage: window.sessionStorage
});

export default new Vuex.Store({
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    User: Users
  },
  plugins: [vuexPersist.plugin]
});
